import { render, staticRenderFns } from "./LogoCpt.vue?vue&type=template&id=6281a68e&"
import script from "./LogoCpt.vue?vue&type=script&lang=ts&"
export * from "./LogoCpt.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports